module.exports = __webpack_public_path__ + "img/mollie-applepay.d30eaea.svg";